module.exports = __webpack_public_path__ + "img/宣传_156.d8be31b9.jpg";